import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

const EARNINGS_INSIGHT_DRAWER_ID = 'earningsInsight';

export enum SubTabsType {
  Preview = 'preview',
  Recap = 'recap',
}

export const useEarningsInsightDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const { trackEarningsInsightDrawerOpen } = usePosthogEvents();
  const isDrawerOpen =
    params[queryKeys.activeDrawer] === EARNINGS_INSIGHT_DRAWER_ID;
  const activeEntityTag = params[queryKeys.activeEarningsEntity];
  const earningsId = params[queryKeys.earningsId];

  const subtabs = [SubTabsType.Preview, SubTabsType.Recap];
  const foundTabIndex = subtabs.findIndex(
    tab => tab === params[queryKeys.activeDrawerTab]
  );
  const activeTabIndex = foundTabIndex !== -1 ? foundTabIndex : 0;
  const activeTab = subtabs[activeTabIndex];

  const openDrawer = ({
    entityTag,
    earningsId,
    subtab,
    source,
  }: {
    entityTag: string;
    earningsId: string;
    subtab?: SubTabsType;
    source: PosthogTrackingSource;
  }) => {
    const drawerType = subtab ?? SubTabsType.Preview;
    trackEarningsInsightDrawerOpen(source, drawerType);
    setQueryParams({
      [queryKeys.activeDrawer]: EARNINGS_INSIGHT_DRAWER_ID,
      [queryKeys.activeDrawerTab]: drawerType,
      [queryKeys.activeEarningsEntity]: entityTag,
      [queryKeys.earningsId]: earningsId,
    });
  };

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.activeDrawerTab,
      queryKeys.activeEarningsEntity,
      queryKeys.earningsId,
    ]);

  const switchTab = (index: number) => {
    setQueryParams({ [queryKeys.activeDrawerTab]: subtabs[index] });
  };

  return {
    closeDrawer,
    openDrawer,
    isDrawerOpen,
    activeEntityTag,
    switchTab,
    activeTabIndex,
    activeTab,
    earningsId,
  };
};
